import styled from 'styled-components'
import { Link } from '@navent-jobs/ui-kit/components/link'

import Card from '../../../../components/card'
import IsoImage from '../../../../assets/images/iso-bumeran.svg'

export const ListadoAvisoCard = styled(Card)`
  margin-bottom: 12px;
`

export const SponsorComponent = styled.div`
  box-sizing: border-box;
  margin-bottom: 16px;
  overflow: hidden;
`

export const SponsorFooter = styled.div`
  border-radius: 8px;
  background-color: white;
  display: flex;
  background-image: url(${IsoImage});
  background-repeat: no-repeat;
  background-position-x: 102%;
  background-size: contain;
  flex-direction: column;
  padding: 12px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    justify-content: space-between;
    align-items: center;
    background-position-x: 95%;
    padding: 0 16px;
    height: 68px;
    flex-direction: row;
  }
`

export const SponsorBody = styled.div``

export const CompanyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const CompanyLogo = styled.img`
  max-width: 80px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.grey24};
  margin-right: 16px;
  width: 68px;
  height: 44px;
  display: inline-block;
  vertical-align: top;
  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    vertical-align: middle;
  }
`

export const CompanyTitle = styled.div`
  display: inline-block;
  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    vertical-align: middle;
  }
`
export const Strong = styled.strong`
  display: inline-block;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    display: inline-block;
    width: auto;
  }
`

export const SponsorLink = styled(Link)`
  min-width: 160px;
  width: 100%;
  margin-top: 12px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    width: auto;
    margin-top: 0;
  }
`
